import type { PortableTextMarkComponentProps } from '@portabletext/react';
import type { SanityReference } from '@sanity/client';
import * as style from './markDefs.module.css';

export const fileComponentHyperlinkGroq = /* groq */ `{
    _type,
    "url": coalesce(file.asset->url, ""),
}`;

export function FileComponentHyperlink({
    value,
    children,
}: PortableTextMarkComponentProps<SanityReference & { _type: 'fileComponent'; url: string }>) {
    return (
        <a href={value?.url} download className={style.fileHyperLink}>
            {children}
        </a>
    );
}
